<template>
  <div style="text-align: left">
    <a-form-model
      v-model="data"
      :model="model"
      :errors="errors"
      :warnings="warnings"
      :config="{ dense: true, readonly, hideDetails: true, opt: config.opt || null }"
      @validate="onInput($event)"
    />
    <div class="text-overline mb-0">Варианты результатов</div>
    <v-row v-for="(el, i) in results" :key="i" no-gutters class="mb-4">
      <v-col class="flex-grow-1 flex-shrink-0">
        <a-input-lead-result
          :value="results[i]"
          :values="data"
          :config="config"
          :readonly="![-2, i].includes(changed) || readonly"
          @commit="
            commit($event, i);
            $emit('input', data);
          "
          @change="changed = i"
        />
        <hr v-if="i < results.length - 1" class="mb-0 mt-3" />
      </v-col>
      <v-col v-if="!readonly" class="flex-grow-0 flex-shrink-1">
        <div class="pt-2">
          <v-btn elevation="0" fab small color="red" bottom @click="onClickDel(i)" :disabled="![-2, i].includes(changed)">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div class="text-left mt-1">
      <v-btn v-if="!readonly" elevation="2" fab x-small color="green" top left @click="onClickAdd" :disabled="![-2].includes(changed)">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { fillForm, submitForm, removeEl, getAccess, genModel, libChecks } from "@/components/mixings";
export default {
  components: {
    //ButtonItem: () => import("./button"),
  },
  mixins: [fillForm, submitForm, removeEl, getAccess, genModel, libChecks],
  props: {
    value: Object,
    object: {
      type: Object,
      default: () => {
        id: 0;
      },
    },
    values: {
      type: Object,
      default: () => {},
    },
    config: {
      type: Object,
      default: () => {
        return { dense: true, hideDetails: "auto" };
      },
    },
    readonly: { type: Boolean, default: false },
    type: { type: Number, default: 0 },
  },
  data() {
    return {
      changed: -2,
    };
  },
  computed: {
    model() {
      let type = [
        { value: "button", text: "Кнопки" },
        { value: "select", text: "Выбор" },
      ];
      let res = [
        { name: "type", title: "Тип", type: "select", options: type, validator: ["req"], default: "select" },
        { name: "results", validator: ["req"] },
      ];
      return res;
    },
    results: {
      set(v) {
        this.data.results = [...v];
      },
      get() {
        let res = [];
        if (this.value) res = this.value?.results || [];
        if (!Array.isArray(res)) res = [];
        return res;
      },
    },
  },
  created() {
    this.reset();
  },
  watch: {
    value(v) {
      this.reset();
    },
    "object.id"(v) {},
  },
  methods: {
    async fetchData(id) {
      for (const name in this.value) {
        this.$set(this.data, name, this.value[name]);
      }
      this.fillFormFromModel(this.model); // this.data = Object.assign({}, this.value || {});
    },
    onInput(e) {
      if (e == "type") {
        this.fillFormValidators(this.model);
      }
      this.validate(e);
      this.$emit("input", this.data);
    },
    async reset() {
      this.changed = this.changed == this.results.length - 1 ? this.changed : -2;
      this.fetchData();
    },
    onChange(i) {
      this.changed = i;
    },
    commit(e, i = -1) {
      let d = [...this.results];
      if (i == -1) {
        d = [...d, e];
      } else d[i] = e;
      this.changed = -2;
      this.results = d;
      //this.$emit("input", d);
    },
    onClickDel(key) {
      let e = this.results;
      e.splice(key, 1);
      e.forEach((el, i) => {
        el.numb = i + 1;
      });
      this.results = e;
      this.changed = this.changed == this.results.length - 1 ? this.changed : -2;
    },
    onClickAdd() {
      this.results.push({});
      this.changed = this.results.length - 1;
      return;
    },
  },
};
</script>
